var _style, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempHumi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    viewBox: "213 252 184 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000170983852309662235670000014091745575276112270_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.4,437.7V283.5c0-7-10.5-7-10.5,0v154.2c-17.3,2.7-29.6,18.3-28.2,35.8c1.4,17.5,16,30.9,33.5,30.9   c17.5,0,32.1-13.5,33.5-30.9C317.1,456.1,304.8,440.5,287.4,437.7L287.4,437.7z M282.2,494c-9.3,0-17.8-5.6-21.3-14.2   c-3.6-8.6-1.6-18.6,5-25.2c6.6-6.6,16.5-8.6,25.2-5c8.6,3.6,14.2,12,14.2,21.3C305.3,483.6,294.9,493.9,282.2,494L282.2,494z    M282.2,494"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 213,
    y: 252,
    width: 184,
    height: 288
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000019644108934311549960000017964080430143045249_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000019644108934311549960000017964080430143045249_)"
    },
    d: "M366.8,272.6    c-1-1.2-2.6-1.9-4.2-1.9c-1.6,0-3.1,0.7-4.2,1.9c-3,3.9-29.4,38.5-29.4,55.5c0,18.5,15,33.6,33.6,33.6c18.5,0,33.6-15,33.6-33.6    C396.2,311.1,369.8,276.5,366.8,272.6L366.8,272.6z M362.6,351.2c-12.7,0-23.1-10.3-23.1-23.1c0-8.8,12.8-29.4,23.1-43.5    c10.3,14.1,23.1,34.7,23.1,43.5C385.7,340.8,375.3,351.1,362.6,351.2L362.6,351.2z M362.6,351.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000019644108934311549960000017964080430143045249_)"
    },
    d: "M315.8,411.4v-125    c0-18.5-15-33.6-33.6-33.6c-18.5,0-33.6,15-33.6,33.6v125c-26.4,14.9-39.9,45.4-33,75c6.9,29.6,32.4,51.1,62.7,52.8    c1.3,0.1,2.6,0.1,3.9,0.1c31.1,0,58.2-20.9,66.1-51C356.2,458.2,342.8,426.6,315.8,411.4L315.8,411.4z M322,512.9    c-11.5,11-27.2,16.7-43.1,15.7c-26.2-1.5-48.1-20.4-53.4-46c-5.3-25.7,7.3-51.7,30.7-63.4c1.8-0.9,2.9-2.7,2.9-4.7V286.3    c0-12.7,10.3-23.1,23.1-23.1c12.7,0,23.1,10.3,23.1,23.1V304h-5.1c-7,0-7,10.5,0,10.5h5.1v12h-5.1c-7,0-7,10.5,0,10.5h5.1v12h-5.1    c-7,0-7,10.5,0,10.5h5.1v12h-5.1c-7,0-7,10.5,0,10.5h5.1v32.5c0,2,1.1,3.8,2.9,4.7c16.9,8.5,28.5,24.6,31.3,43.3    C342.2,481.1,335.7,500,322,512.9L322,512.9z M322,512.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempHumi);
export default __webpack_public_path__ + "static/media/temp-humi.91a5a5ab1f010987a72ebefe9d9a9c41.svg";
export { ForwardRef as ReactComponent };